import { render, staticRenderFns } from "./ContractSection.vue?vue&type=template&id=25dfa977&"
import script from "./ContractSection.vue?vue&type=script&lang=js&"
export * from "./ContractSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports